/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Booking_Error_Slot_UnavailableInputs */

const en_booking_error_slot_unavailable = /** @type {(inputs: Booking_Error_Slot_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`That time is no longer available. Please pick another.`)
};

const es_booking_error_slot_unavailable = /** @type {(inputs: Booking_Error_Slot_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ese horario ya no está disponible. Elige otro.`)
};

const de_booking_error_slot_unavailable = /** @type {(inputs: Booking_Error_Slot_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diese Uhrzeit ist nicht mehr verfügbar. Bitte wählen Sie eine andere.`)
};

const zh_booking_error_slot_unavailable = /** @type {(inputs: Booking_Error_Slot_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`该时间已不可预约，请选择其他时间。`)
};

const ar_booking_error_slot_unavailable = /** @type {(inputs: Booking_Error_Slot_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`هذا الوقت لم يعد متاحاً. يُرجى اختيار وقت آخر.`)
};

const fr_booking_error_slot_unavailable = /** @type {(inputs: Booking_Error_Slot_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ce créneau n'est plus disponible. Veuillez en choisir un autre.`)
};

const vi_booking_error_slot_unavailable = /** @type {(inputs: Booking_Error_Slot_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Khung giờ đó không còn trống. Vui lòng chọn giờ khác.`)
};

const sw_booking_error_slot_unavailable = /** @type {(inputs: Booking_Error_Slot_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Muda huo haupatikani tena. Tafadhali chagua mwingine.`)
};

const th_booking_error_slot_unavailable = /** @type {(inputs: Booking_Error_Slot_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เวลานี้ไม่ว่างแล้ว โปรดเลือกเวลาอื่น`)
};

const bs_booking_error_slot_unavailable = /** @type {(inputs: Booking_Error_Slot_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Taj termin više nije dostupan. Odaberite drugi.`)
};

const ja_booking_error_slot_unavailable = /** @type {(inputs: Booking_Error_Slot_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`その時間は予約できなくなりました。別の時間を選択してください。`)
};

const ko_booking_error_slot_unavailable = /** @type {(inputs: Booking_Error_Slot_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`해당 시간은 더 이상 예약할 수 없습니다. 다른 시간을 선택해 주세요.`)
};

const pt_booking_error_slot_unavailable = /** @type {(inputs: Booking_Error_Slot_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esse horário não está mais disponível. Escolha outro.`)
};

const it_booking_error_slot_unavailable = /** @type {(inputs: Booking_Error_Slot_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Questo orario non è più disponibile. Scegline un altro.`)
};

const sv_booking_error_slot_unavailable = /** @type {(inputs: Booking_Error_Slot_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Den tiden är inte längre ledig. Välj en annan.`)
};

const nl_booking_error_slot_unavailable = /** @type {(inputs: Booking_Error_Slot_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dat tijdstip is niet meer beschikbaar. Kies een ander tijdstip.`)
};

const da_booking_error_slot_unavailable = /** @type {(inputs: Booking_Error_Slot_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Det tidspunkt er ikke længere ledigt. Vælg venligst et andet.`)
};

const nb_booking_error_slot_unavailable = /** @type {(inputs: Booking_Error_Slot_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Det tidspunktet er ikke lenger ledig. Velg et annet.`)
};

const fi_booking_error_slot_unavailable = /** @type {(inputs: Booking_Error_Slot_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aika ei ole enää vapaana. Valitse toinen aika.`)
};

const pl_booking_error_slot_unavailable = /** @type {(inputs: Booking_Error_Slot_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ta godzina nie jest już dostępna. Wybierz inną.`)
};

const ru_booking_error_slot_unavailable = /** @type {(inputs: Booking_Error_Slot_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Это время больше недоступно. Выберите другое.`)
};

const tr_booking_error_slot_unavailable = /** @type {(inputs: Booking_Error_Slot_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bu saat artık müsait değil. Lütfen başka bir saat seçin.`)
};

const hi_booking_error_slot_unavailable = /** @type {(inputs: Booking_Error_Slot_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`यह समय अब उपलब्ध नहीं है। कृपया कोई दूसरा समय चुनें।`)
};

const id_booking_error_slot_unavailable = /** @type {(inputs: Booking_Error_Slot_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Waktu tersebut sudah tidak tersedia. Silakan pilih waktu lain.`)
};

const ms_booking_error_slot_unavailable = /** @type {(inputs: Booking_Error_Slot_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Masa itu tidak lagi tersedia. Sila pilih masa lain.`)
};

const cs_booking_error_slot_unavailable = /** @type {(inputs: Booking_Error_Slot_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tento čas už není k dispozici. Vyberte prosím jiný.`)
};

const el_booking_error_slot_unavailable = /** @type {(inputs: Booking_Error_Slot_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Αυτή η ώρα δεν είναι πλέον διαθέσιμη. Επιλέξτε άλλη.`)
};

const he_booking_error_slot_unavailable = /** @type {(inputs: Booking_Error_Slot_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`השעה הזו כבר לא פנויה. בחרו שעה אחרת.`)
};

const af_booking_error_slot_unavailable = /** @type {(inputs: Booking_Error_Slot_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Daardie tyd is nie meer beskikbaar nie. Kies asseblief 'n ander een.`)
};

const hu_booking_error_slot_unavailable = /** @type {(inputs: Booking_Error_Slot_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ez az időpont már nem szabad. Kérjük, válassz másikat.`)
};

/**
* | output |
* | --- |
* | "That time is no longer available. Please pick another." |
*
* @param {Booking_Error_Slot_UnavailableInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const booking_error_slot_unavailable = /** @type {((inputs?: Booking_Error_Slot_UnavailableInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Booking_Error_Slot_UnavailableInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_booking_error_slot_unavailable(inputs)
	if (locale === "de") return de_booking_error_slot_unavailable(inputs)
	if (locale === "zh") return zh_booking_error_slot_unavailable(inputs)
	if (locale === "ar") return ar_booking_error_slot_unavailable(inputs)
	if (locale === "fr") return fr_booking_error_slot_unavailable(inputs)
	if (locale === "vi") return vi_booking_error_slot_unavailable(inputs)
	if (locale === "sw") return sw_booking_error_slot_unavailable(inputs)
	if (locale === "th") return th_booking_error_slot_unavailable(inputs)
	if (locale === "bs") return bs_booking_error_slot_unavailable(inputs)
	if (locale === "ja") return ja_booking_error_slot_unavailable(inputs)
	if (locale === "ko") return ko_booking_error_slot_unavailable(inputs)
	if (locale === "pt") return pt_booking_error_slot_unavailable(inputs)
	if (locale === "it") return it_booking_error_slot_unavailable(inputs)
	if (locale === "sv") return sv_booking_error_slot_unavailable(inputs)
	if (locale === "nl") return nl_booking_error_slot_unavailable(inputs)
	if (locale === "da") return da_booking_error_slot_unavailable(inputs)
	if (locale === "nb") return nb_booking_error_slot_unavailable(inputs)
	if (locale === "fi") return fi_booking_error_slot_unavailable(inputs)
	if (locale === "pl") return pl_booking_error_slot_unavailable(inputs)
	if (locale === "ru") return ru_booking_error_slot_unavailable(inputs)
	if (locale === "tr") return tr_booking_error_slot_unavailable(inputs)
	if (locale === "hi") return hi_booking_error_slot_unavailable(inputs)
	if (locale === "id") return id_booking_error_slot_unavailable(inputs)
	if (locale === "ms") return ms_booking_error_slot_unavailable(inputs)
	if (locale === "cs") return cs_booking_error_slot_unavailable(inputs)
	if (locale === "el") return el_booking_error_slot_unavailable(inputs)
	if (locale === "he") return he_booking_error_slot_unavailable(inputs)
	if (locale === "af") return af_booking_error_slot_unavailable(inputs)
	if (locale === "hu") return hu_booking_error_slot_unavailable(inputs)
	return en_booking_error_slot_unavailable(inputs)
});